import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.zentrale-liste2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsZentraleListe2Effects {

    ZentraleListe2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ZENTRALE_LISTE2),
        mergeMap((x: ac.GetZentraleListe2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getZentraleListe2(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetZentraleListe2ErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetZentraleListe2FehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ZentraleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ZentraleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ZentraleQueryService);
        }
        return this.service;
    }
}
